/** Shared Searcher helpers for enrollment list pages. */

export function filtersToQueryParams(state) {
  const prms = Object.keys(state.filters || {})
    .filter((f) => !!state.filters[f]?.filter)
    .map((f) => state.filters[f].filter);

  if (!state.beforeCursor && !state.afterCursor) {
    prms.push(`first: ${state.pageSize}`);
  }
  if (state.afterCursor) {
    prms.push(`after: "${state.afterCursor}"`);
    prms.push(`first: ${state.pageSize}`);
  }
  if (state.beforeCursor) {
    prms.push(`before: "${state.beforeCursor}"`);
    prms.push(`last: ${state.pageSize}`);
  }
  if (state.orderBy) {
    prms.push(`orderBy: ["${state.orderBy}"]`);
  }
  return prms;
}

export function enrollmentRowIdentifier(r) {
  return r.uuid;
}
